module.exports = __webpack_public_path__ + "img/5_63.8235cacf.png";